export const externalLink = (link) => {
  return link?.includes("http") ? link : "https://" + link;
};
